module.exports = __webpack_public_path__ + "static/media/icon-features-events.47bc04df.svg";